module.exports = __webpack_public_path__ + "img/base_restauration_cereales.e5552161.svg";